var angular = require('angular')
var moment = require('moment')
require('../../services/appointments.service.js')
require('../../services/places.service.js')
require('../../services/app-data.service.js')
require('../../components/appointment-branch-header/appointment-branch-header.component.js')

angular.module('AemBranchesAppointments')
  .component('appointmentCreate', {
    template: require('./appointment-create.component.tpl.html'),
    controller: AppointmentCreateCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

AppointmentCreateCtrl.$inject = ['appLoader', 'appointmentsService', 'placesService',
  '$routeParams', '$location', 'i18n', 'userTracking', '$filter', 'appDataService',
  '$q', 'appointmentsTrackingDataservice']

function AppointmentCreateCtrl (appLoader, appointmentsService, placesService,
  $routeParams, $location, i18n, userTracking, $filter, appDataService,
  $q, appointmentsTrackingDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.error = null
    vm.branch = null
    vm.date = new Date(+$routeParams.timeslot)
    vm.resolving = false
    vm.errorOrderInPast = false
    vm.errorOrderRaceCondition = false
    vm.branchId = $routeParams.branchId

    vm.nameId = 'name_' + guid()
    vm.name = null
    vm.surnameId = 'surname_' + guid()
    vm.surname = null
    vm.phoneId = 'phone_' + guid()
    vm.phoneCodes = []
    vm.phoneCode = vm.phoneCodes[0]
    vm.phone = null
    vm.phonePattern = /^\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*$/
    vm.emailId = 'email_' + guid()
    vm.email = null
    vm.emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    vm.descriptionId = 'description_' + guid()
    vm.description = null
    vm.topicId = 'topic_' + guid()
    vm.topic = null
    vm.topics = ['MYLOANS', 'MYPAYMENTS', 'MYHOUSING', 'MYSAVINGS', 'MYINSURANCE',
      'MYFUTURE', 'ENERGYGAS', 'MYBUSINESS','FINANCIALADVICE']
      .map(function (element) {
        return {
          key: element,
          description: $filter('translate')('BRANCHES_APPOINTMENTS.CREATE.TOPIC.TOPICS.' + element)
        }
      })
    vm.showError = showError
    vm.create = create

    $q.all([
      placesService.branchDetail($routeParams.branchId),
      appDataService.widgetParamsPromise
    ])
      .then(function (res) {
        vm.branch = res[0].data
        vm.phoneCodes = res[1].data.countryCallingCodes || ['+420', '+421']
        vm.phoneCode = vm.phoneCodes[0]
      })
      .catch(function (err) {
        vm.error = err
      })
      .finally(appLoader.hide)
  }

  function create () {
    if (vm.form_create.input_name.$invalid) {
      userTracking.onValidityFailure('firstname')
    }
    if (vm.form_create.input_surname.$invalid) {
      userTracking.onValidityFailure('lastname')
    }
    if (vm.form_create.input_phone.$invalid) {
      userTracking.onValidityFailure('phone')
    }
    if (vm.form_create.input_email.$invalid) {
      userTracking.onValidityFailure('email')
    }

    if (vm.form_create.$invalid) {
      userTracking.onResponse(null, 'failed')
      return
    }

    var data = {
      requireMeetingRoom: false,
      branchId: $routeParams.branchId,
      attendanceType: appDataService.serviceGroups.ATTENDANCE.value || null,
      assistanceType: appDataService.serviceGroups.ASSISTANCE.value || null,
      language: i18n.langCode,
      customer: {
        firstName: vm.name.trim(),
        lastName: vm.surname.trim(),
        phoneNumber: vm.phoneCode + vm.phone.replace(/\s/g, ''),
        email: vm.email.trim()
      },
      timeslot: {
        start: moment(+$routeParams.timeslot).format(),
        end: moment(+$routeParams.timeslot).add(appDataService.MEETING_LENGTH_MINUTES, 'minutes').format()
      },
      description: getDescription(vm.description),
      topic: vm.topic.key.split('_')[0],
      meetingType: appointmentsTrackingDataservice.getSourceId() || 'FROM_WEB_ATM',
      source: appointmentsTrackingDataservice.getSourceId() || 'FROM_WEB_ATM'
    }
    appLoader.show()
    vm.resolving = true
    userTracking.onRequest(data)
    appointmentsService.create(data)
      .then(function (res) {
        appointmentsTrackingDataservice.removeSessionStorage()
        userTracking.onResponse(res)
        $location.path('/appointment/' + res.data.id)
      })
      .catch(function (err) {
        if (err.status === 400 || err.status === 404) {
          processBeErrors((err.data && err.data.errors) || [])
        } else {
          vm.error = err
        }
        userTracking.onResponse(null, 'failed')
      })
      .finally(function () {
        vm.resolving = false
        appLoader.hide()
      })
  }

  function showError (fieldName) {
    return vm.form_create.$submitted && vm.form_create[fieldName].$invalid
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }

  function processBeErrors (errors) {
    vm.form_create.input_description.$setValidity('beTooLong', true)
    var unhandledErrors = errors
      .reduce(function (acc, error) {
        if (error.error === 'FIELD_TOO_LONG' && error.scope === 'description') {
          vm.form_create.input_description.$setValidity('beTooLong', false)
        } else if (error.error === 'FIELD_INVALID' && error.scope === 'timeSlot.start') {
          vm.errorOrderInPast = true
        } else if (error.error === 'TIMESLOT_NOT_AVAILABLE') {
          vm.errorOrderRaceCondition = true
        } else {
          acc.push(error)
        }
        return acc
      }, [])

    if (unhandledErrors.length) {
      vm.error = unhandledErrors
    }
  }

  function getDescription (formDescription) {
    var ret = (formDescription && formDescription.replace(/\s/g, ' ').trim()) || ''
    return ret || null
  }
}
